import { Injectable, EventEmitter } from '@angular/core';
import { AppHttpService } from '../app-http.service';
import { CartService } from '../cart/cart.service';
import { SharedService } from '../shared.service';
import * as moment from 'moment';

@Injectable()
export class CheckoutService {
  private streets = null;
  private confirmationIsValid = true;
  private maxMonthlyCost = 1000; // defaults to 1000. Is set via api/v2/me if user is logged in

  confirmationUpdated: EventEmitter<any> = new EventEmitter();

  constructor(
    private httpService: AppHttpService,
    private cartService: CartService,
    private sharedService: SharedService
  ) {}

  emailPattern() {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  }

  getMe() {
    return this.httpService.getMe();
  }

  checkExistingEmail(email) {
    return this.httpService.checkExistingEmail(email);
  }

  validate(type, data) {
    return this.httpService.validate(type, data);
  }

  validatePhone(data) {
    return this.httpService.validatePhone(data);
  }

  validateCoupon(data) {
    data.email = this.sharedService.getLocalStorage('addressData').email;
    return this.httpService.validateCoupon(data);
  }

  validateBankAccount(account, bank) {
    return this.httpService.validateBankAccount(account, bank);
  }

  orders(data) {
    return this.httpService.orders(data);
  }

  formatBirthday(birthDay) {
    return moment(birthDay, 'DD.MM.YYYY').format('YYYY-MM-DD');
  }

  getMaxMonthlyCost() {
    return this.maxMonthlyCost;
  }

  getOrderData() {
    const orderData = this.getAddressData();
    const jokerType = this.sharedService.getJokerType();

    orderData.products = this.cartService.getProductsForOrder();
    orderData.lotteryNumber = this.cartService.getLotteryNumber();
    orderData.lotteryCategory = this.cartService.getLotteryCategory();
    orderData.totalFee = this.cartService.getTotalPriceWithoutDiscount();
    orderData.delayDeploy = this.sharedService.getSiteConfig().delayDeploy;
    orderData.birthDate = this.formatBirthday(orderData.birthday);
    orderData.city = orderData.cities;
    orderData.paymentMethod = orderData.paymentType;
    orderData.wbkz = this.getWbkz();
    orderData.clientId = this.getGoogleClientId();

    if (orderData.paymentType === 'paypal') {
      orderData.paypalReturnCallbackUrl =
        this.sharedService.getSiteConfig().callbackURL;
      orderData.paypalCancelCallbackUrl =
        this.sharedService.getSiteConfig().paypalCancelCallbackUrl;
    }

    if (this.getCouponData()) {
      orderData.coupon = this.getCouponData();
    }
    if (jokerType) {
      orderData.jokerType = jokerType;
    }
    if (this.getSovendusToken()) {
      orderData.sovReqToken = this.getSovendusToken();
    }
    if (this.getAwinId()) {
      orderData.awinId = this.getAwinId();
    }

    delete orderData.cities;

    return orderData;
  }

  cityHelper(cityResponse) {
    // Save all response Object keys to responseData
    const responseData = Object.keys(cityResponse);

    // Check if responseData contains more than one item. If not only save first array
    // item to cities.
    return responseData.length > 1 ? responseData : responseData[0];
  }

  setConfirmValidation(confirmation) {
    this.confirmationIsValid = confirmation;
    this.confirmationUpdated.emit(this.confirmationIsValid);
  }

  getConfirmValidation() {
    return this.confirmationIsValid;
  }

  setStreets(streets) {
    this.streets = streets;
  }

  getStreets(city) {
    return this.streets[city];
  }

  getAllStreets() {
    return this.streets;
  }

  setAddressData(data) {
    if (!data.phoneNumber) {
      delete data.phoneNumber;
    }
    this.sharedService.setLocalStorage('addressData', data);
  }

  getAddressData() {
    return this.sharedService.getLocalStorage('addressData');
  }

  getCouponData() {
    return this.sharedService.getSessionStorage('couponData').code;
  }

  getPrefilledData() {
    return this.sharedService.getLocalStorage('prefilled');
  }

  getWbkz() {
    const siteConfig = this.sharedService.getSiteConfig();
    const wbkzName = siteConfig.cookies.cookieWbkz;

    return this.sharedService.getCookie(wbkzName)
      ? this.sharedService.getCookie(wbkzName)
      : siteConfig.wbkz;
  }

  removeSpaces(value) {
    return value.replace(/ /g, '');
  }

  getGoogleClientId() {
    let clientId;
    try {
      const tracker = this.sharedService.getWindow().ga.getAll()[0];
      clientId = tracker.get('clientId');
    } catch (e) {
      clientId = null;
    }
    return clientId;
  }

  getSovendusToken() {
    return sessionStorage.getItem('sovReqToken');
  }

  getAwinId() {
    return sessionStorage.getItem('awinId');
  }
}
